export function getQueryParams(location) {
    location = location || window.location;
    return (location.search || '').replace(/^\?/, '').split('&')
        .filter((e) => {
            return e && e !== ''
        })
        .reduce((r, e)=>{
            let parts = e.split('=');
            r[parts[0]] = parts[1];
            return r
        }, {})
}

export function getQueryParam(paramName, options) {
    options = options || {};
    let val = getQueryParams(options.location)[paramName];
    if (options.toLowerCase) {
        val = val && val.toLowerCase();
    }
    if (options.validValues && options.validValues.indexOf(val) < 0) {
        val = options.default
    }
    return val || options.defualt;
}

export function queryObjectToString(queryObj) {
    return '?' + Object.keys(queryObj)
        .map(key => `${key}=${queryObj[key]}`)
        .join('&');
}
